import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/LOGO.svg';
import Button from '../components/UI/button/Button';
import AuthInput from '../components/auth-input/AuthInput';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [validationKey, setValidationKey] = useState(0);

  const handleSubmit = () => {
    setValidationKey((prev) => prev + 1);
  };

  const handleValidationComplete = (isValid) => {
    if (isValid) {
      navigate('/check-email');
    }
  };

  return (
    <div className="App">
        <img src={logo} alt="logo" />
        <div className="forgotPasswordInfo">
            <span
            style={{
                fontFamily: 'var(--semibold-text-font-family)',
                color: 'var(--tokens-colors-text-basic)',
                fontSize: 'var(--info-text-font-size)',
                fontWeight: 'var(--bottom-tab-lable-font-weight)',
            }}
            >
                Сброс пароля
            </span>
            <span
            style={{
                fontFamily: 'var(--regular-text-font-family)',
                color: 'var(--tokens-colors-text-basic)',
                fontSize: 'var(--semibold-text-font-size)',
                width: '345px',
                textAlign: 'center',
                paddingTop: 'var(--tokens-paddings-gaps-container-basic)',
                fontWeight: 'var(--regular-text-font-weight)',
                lineHeight: 'var(--regular-text-line-height)',
            }}
            >
                Введите адрес электронной почты, связанный с вашей учетной записью
            </span>
      </div>

      <AuthInput
        text='Email'
        type='text'
        placeholder='example@example.ru'
        validationKey={validationKey}
        errorMessage='Пожалуйста, введите эл. почту'
        onValidationComplete={handleValidationComplete}
      />
      <Button onClick={handleSubmit}>
        Продолжить
      </Button>
      <Link to="/" className="backToLoginLink">
        Вернуться, чтобы войти
      </Link>
    </div>
  )
}

export default ForgotPasswordPage;